import React, { useState, useEffect } from "react";

import PanelTemplate from "../../templates/Panel";
import DotStatus from "../../components/DotStatus";
import BoxTabs from "../../components/BoxTabs";
import Modal from "../../components/Modal";
import InputSelect from "../../components/InputSelect";
import Input from "../../components/Input";
import InputRadio from "../../components/InputRadio";
import InputEditor from "../../components/InputEditor";
import InputCheckboxes from "../../components/InputCheckboxes";
import PageFooter from "../../components/PageFooter";
import Button from "../../components/Button";
import InputColors from "../../components/InputColors";
import PageHeader from "../../components/PageHeader";
import InputTextarea from "../../components/InputTextarea";
import Table from "../../components/Table";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import api from "../../services/api";
import { renderError } from "../../helpers/errors";
import { Loading } from "../../components/Loading";
import { createOptions } from "../../helpers/selects";
import states from "../../seeds/states";
import axios from "axios";
import { toast } from "react-toastify";
import { convertIntToMoney, convertMoenyToInt, convertPercentageToFloat, convertPercentageToInt } from "../../helpers/conversions";
import { convertToPercentage } from "../../helpers/masks";
import { ModalDelete } from "../../components/ModalDelete";
import ModalCreateQuote from "../Quote/ModalCreateQuote";
import moment from "moment";
import origins from "../../seeds/origins";
import { canSeeBrands, getData, hasPermission, hasPlanFeature } from "../../services/auth";
import SelectCustomerCompany from "../../components/selects/SelectCustomerCompany";
import SelectBrand from "../../components/selects/SelectBrand";
import InputCheckboxUnique from "../../components/InputCheckboxUnique";
import AddressTab from "../../components/tabs/AddressTab";
import CustomerLogotypes from "../../components/CustomerLogotypes";
import InputEditorFull from "../../components/InputEditorTiny";

const types = [
    {label: 'Fornecedor de gravação', value: 'customization'},
    {label: 'Fornecedor de produto', value: 'product'},
    {label: 'Cliente', value: 'customer'},
    {label: 'Faturamento', value: 'billing'},
    {label: 'Transportadora', value: 'shipping'}
];

const QuotesTab = ({quotes}) => {
    const [data, setData] = useState({header: [], rows: []});

    useEffect(() => {
        generateData();
    }, []);    

    const generateData = () => {
        const header = ['Código', 'Data da solicitação', 'Status'];
        const rows = [];
        
        quotes.map(quote => {
            rows.push({
                data: [
                    quote.code,
                    moment(quote.created_at).format('DD/MM/YYYY HH:mm'),
                    <>
                        <DotStatus color={quote.status_color} size={15} />
                        {quote.status_name}
                    </>
                ],
                to: `/quote/edit/${quote.id}`
            });
        });

        setData({header, rows});
    }

    return (
        <Table header={data.header} rows={data.rows} />
    );
}

const OrdersTab = ({orders}) => {
    const [data, setData] = useState({header: [], rows: []});

    useEffect(() => {
        generateData();
    }, []);

    const generateData = () => {
        const header = ['Código', 'Data da solicitação', 'Status'];
        const rows = [];
        
        orders.map(order => {
            rows.push({
                data: [
                    order.code,
                    moment(order.created_at).format('DD/MM/YYYY HH:mm'),
                    <>
                        <DotStatus color={order.status_color} size={15} />
                        {order.status_name}
                    </>
                ],
                to: `/order/edit/${order.id}`
            });
        });

        setData({header, rows});
    }

    return (
        <Table header={data.header} rows={data.rows} />
    );
}

const CustomerDetailsTab = ({
    companies,
    setCompanies,
    customer, 
    name,
    setName,
    email,
    setEmail,
    cpf,
    setCpf,
    phone,
    setPhone,
    selectedCompanies,
    setSelectedCompanies,
    selectedBrands,
    setSelectedBrands,
    zipCode,
    setZipCode,
    street,
    setStreet,
    number,
    setNumber,
    complement,
    setComplement,
    district,
    setDistrict,
    city,
    setCity,
    state,
    setState,
    type,
    setType,
    admins,
    admin,
    setAdmin,
    canViewPrice,
    setCanViewPrice,
    comments,
    setComments
}) => {
    useEffect(() => {
        setTypesAndAdmin();
    }, [selectedCompanies])

    const setTypesAndAdmin = () => {
        let selectedAdmin = admin;
        let selectedTypes = [...type];
        console.log(selectedTypes);
        let sCompanies = companies.filter(company => selectedCompanies.includes(company.id));
        sCompanies.map(selectedCompany => {
            if(selectedCompany.admin_id !== null){
                selectedAdmin = selectedCompany.admin_id;
            }
            selectedCompany.type.map(type => {
                if(!selectedTypes.includes(type)){
                    selectedTypes.push(type);
                }
            });
        });
        setType(selectedTypes);
        setAdmin(selectedAdmin);
    }

    return (
        <div>
            <h2 className="section-title">Dados cadastrais</h2>
            <div className="row">
                <div className="col-2">
                    <Input type={`text`} label={`Código`} value={customer?.code ?? ''} disabled={true} />
                </div>
                <div className="col-4">
                    <SelectCustomerCompany
                        isMulti={true}
                        selectedCustomerCompany={selectedCompanies}
                        setSelectedCustomerCompany={setSelectedCompanies}
                        changeCompanies={setCompanies}
                    />
                </div>
                <div className="col-3">
                    <InputSelect label={`Marcadores`} options={types} value={type} change={setType} isMulti={true} />
                </div>
                {canSeeBrands() &&
                    <div className="col-3">
                        <SelectBrand isMulti={true} selectedBrand={selectedBrands} setSelectedBrand={setSelectedBrands} minSearch={3} />
                    </div>
                }
                {type.includes('customer') &&
                    <div className="col-3">
                        <InputSelect label={`Responsável`} options={createOptions(admins, 'name', 'id', true)} value={admin} change={setAdmin} />
                    </div>
                }
                <div className="col-5">
                    <Input type={`text`} label={`Nome`} value={name} change={setName} />
                </div>
                <div className="col-5">
                    <Input type={`text`} label={`CPF`} value={cpf} change={setCpf} mask={`convertToCpf`} />
                </div>
            </div>
            <div className="row">
                <div className="col-4">
                    <Input type={`text`} label={`Telefone`} value={phone} change={setPhone} mask={`convertToPhone`} />
                </div>
                <div className="col-4">
                    <Input type={`text`} label={`E-mail`} value={email} change={setEmail} />
                </div>
            </div>

            {hasPlanFeature('price_display') && getData().price_display_option === 'only_approved_can_view' &&
                <div style={{ marginBottom: 40}}>
                    <h2 className="section-title">Exibição de preços</h2>
                    {selectedCompanies.length === 0 &&
                        <InputCheckboxUnique
                            label={`Pode ver preços no site`}
                            checked={canViewPrice} 
                            change={setCanViewPrice} 
                        />
                    }
                    {selectedCompanies.length > 0 &&
                        <p>Essa pessoa está vinculada a uma ou mais empresas e, por isso, é necessário definir em cada empresa se ela pode ou não visualizar os preços.</p>
                    }
                </div>
            }

            <h2 className="section-title">Endereço</h2>
            <div className="row">
                <div className="col-3">
                    <Input type={`text`} label={`CEP`} value={zipCode} change={setZipCode} mask={`convertToCep`} />
                </div>
            </div>
            <div className="row">
                <div className="col-6">
                    <Input type={`text`} label={`Logradouro`} value={street} change={setStreet} />
                </div>
                <div className="col-3">
                    <Input type={`text`} label={`Número`} value={number} change={setNumber} />
                </div>
                <div className="col-3">
                    <Input type={`text`} label={`Complemento`} value={complement} change={setComplement} />
                </div>
            </div>
            <div className="row">
                <div className="col-3">
                    <InputSelect label={`Estado`} options={states} value={state} change={setState} />
                </div>
                <div className="col-3">
                    <Input type={`text`} label={`Cidade`} value={city} change={setCity} />
                </div>
                <div className="col-3">
                    <Input type={`text`} label={`Bairro`} value={district} change={setDistrict} />
                </div>
            </div>

            <h2 className="section-title">Observações</h2>
            <div className="row">
                <div className="col-6">
                    <InputEditorFull label={`Observações`} value={comments} change={setComments} />
                </div>
            </div>
        </div>
    );
}

export const CustomerEdit = () => {
    const { id } = useParams();
    const navigete = useNavigate();
    const location = useLocation();

    const [loading, setLoading] = useState(true);
    const [companies, setCompanies] = useState([]);
    const [customer, setCustomer] = useState(null);
    const [selectedBrands, setSelectedBrands] = useState([]);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [cpf, setCpf] = useState("");
    const [selectedCompanies, setSelectedCompanies] = useState([]);
    const [type, setType] = useState([]); 

    const [zipCode, setZipCode] = useState("");
    const [street, setStreet] = useState("");
    const [number, setNumber] = useState("");
    const [complement, setComplement] = useState("");
    const [district, setDistrict] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [admin, setAdmin] = useState(null);

    const [canViewPrice, setCanViewPrice] = useState(false);

    const [confirmDelete, setConfirmDelete] = useState(false);

    const [showResetPassword, setShowResetPassword] = useState(false);
    const [resettingPassword, setResettingPassword] = useState(false);
    const [newPassword, setNewPassword] = useState(null);
    const [passwordEmailSent, setPasswordEmailSent] = useState(false);
    const [admins, setAdmins] = useState([]);

    const [comments, setComments] = useState("");

    useEffect(() => {
        getCustomer();
        getAdmins();
    }, []);

    useEffect(() => {
        getAddress();
    }, [zipCode]);

    const getAdmins = () => {
        api.get(`/list`).then(res => {
            setAdmins(res.data.resources);
        });
    }

    const getCustomerListReturnUrl = () => {
        const params = new URLSearchParams(location.search);
        const returnTo = params.get('return_to');

        return returnTo && returnTo.startsWith('/customer/list') ? returnTo : '/customer/list';
    }

    const deleteCustomer = () => {
        setLoading(true);

        api.delete(`/customer/${id}`).then(res => {
            navigete(getCustomerListReturnUrl());
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    // Reset de senha: quem é cadastrado pelo painel nasce sem senha e não
    // consegue entrar no site da marca. A senha volta em claro de propósito —
    // o tenant costuma repassá-la na hora, sem esperar o e-mail.
    const resetPassword = () => {
        setResettingPassword(true);

        api.post(`/customer/${id}/reset-password`).then(res => {
            setNewPassword(res.data.password);
            setPasswordEmailSent(res.data.email_sent);
        }).catch(error => {
            renderError(error);
            closeResetPassword();
        }).then(() => setResettingPassword(false));
    }

    const closeResetPassword = () => {
        setShowResetPassword(false);
        setNewPassword(null);
    }

    const copyPassword = () => {
        navigator.clipboard.writeText(newPassword).then(() => toast.success('Senha copiada!'));
    }

    const getAddress = () => {
        if(zipCode === null) return;
        let convertedZipCode = zipCode.replace('-', '');
        if(convertedZipCode.length === 8){
            axios.get(`https://viacep.com.br/ws/${convertedZipCode}/json/`).then(res => {
                let address = res.data;
                setStreet(address.logradouro);
                setDistrict(address.bairro);
                setCity(address.localidade);
                setState(address.uf);
            })
        }
    }

    const getCustomer = () => {
        setLoading(true);

        api.get(`/customer/${id}`).then(res => {
            const resource = res.data.resource;
            
            setCustomer(resource);
            setName(resource.name);
            setEmail(resource.email ?? '');
            setPhone(resource.phone);
            setCpf(resource.cpf);
            setSelectedCompanies(resource.companies ? resource.companies.map(company => company.id) : []);
            setSelectedBrands(resource.brands ? resource.brands.map(brand => brand.id) : []);

            setZipCode(resource.zip_code ?? '');
            setStreet(resource.street ?? '');
            setNumber(resource.number ?? '');
            setComplement(resource.complement ?? '');
            setDistrict(resource.district ?? '');
            setCity(resource.city ?? '');
            setState(resource.state ?? '');
            setAdmin(resource.admin_id ?? null);
            setType(resource.type ?? []);
            setComments(resource.comments ?? '');

            setCanViewPrice(resource.can_view_price);
        }).catch(error => {
            console.log(error)
            renderError(error);
        }).then(() => setLoading(false));
    }

    const updateCustomer = () => {
        setLoading(true);
        api.put(`/customer/${customer.id}`, {
            name,
            email,
            phone,
            cpf,
            company_ids: selectedCompanies,
            brands: selectedBrands,
            zip_code: zipCode,
            street,
            number,
            complement,
            district,
            city,
            state,
            type,
            admin_id: admin,
            can_view_price: canViewPrice,
            comments
        }).then(res => {
            getCustomer();
            toast.success('Pessoa atualizada com sucesso');
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    return (
        <>
            <ModalDelete
                show={confirmDelete}
                action={deleteCustomer}
                close={() => setConfirmDelete(false)}
                loading={loading}
            />

            <Modal
                className={`modal-reset-password`}
                show={showResetPassword}
                title={`Resetar senha`}
                close={closeResetPassword}
                footer={newPassword
                    ? <Button type={`primary`} size={`small`} text={`Fechar`} action={closeResetPassword} />
                    : <>
                        <Button type={`primary`} size={`small`} text={`Resetar senha`} action={resetPassword} loading={resettingPassword} />
                        {!resettingPassword &&
                            <Button type={`secondary`} size={`small`} text={`Cancelar`} action={closeResetPassword} />
                        }
                    </>
                }
            >
                <div className="section">
                    {!newPassword &&
                        <p>A senha atual de <strong>{name}</strong> deixa de valer e uma nova é gerada. Ela aparece aqui para você repassar e também é enviada por e-mail.</p>
                    }
                    {newPassword &&
                        <>
                            <p>Nova senha de <strong>{name}</strong>:</p>
                            <div className="new-password">
                                <span>{newPassword}</span>
                                <Button type={`secondary`} size={`small`} text={`Copiar`} action={copyPassword} />
                            </div>
                            <p className="new-password-hint">
                                {passwordEmailSent
                                    ? `Também enviamos por e-mail para ${email}.`
                                    : 'Não foi possível enviar o e-mail. Repasse a senha para a pessoa.'
                                }
                            </p>
                        </>
                    }
                </div>
            </Modal>
            <PanelTemplate id="customer-edit">
                <Loading show={loading} />
                {!loading &&
                    <BoxTabs
                        titles={[
                            'Detalhes da pessoa',
                            'Endereços de entrega',
                            'Endereços de cobrança',
                            'Orçamentos',
                            'Pedidos',
                            'Logotipos'
                        ]}
                        contents={[
                            <CustomerDetailsTab
                                companies={companies}
                                setCompanies={setCompanies}
                                customer={customer}
                                name={name}
                                setName={setName}
                                email={email}
                                setEmail={setEmail}
                                cpf={cpf}
                                setCpf={setCpf}
                                phone={phone}
                                setPhone={setPhone}
                                selectedCompanies={selectedCompanies}
                                setSelectedCompanies={setSelectedCompanies}
                                selectedBrands={selectedBrands}
                                setSelectedBrands={setSelectedBrands}
                                zipCode={zipCode}
                                setZipCode={setZipCode}
                                street={street}
                                setStreet={setStreet}
                                number={number}
                                setNumber={setNumber}
                                complement={complement}
                                setComplement={setComplement}
                                district={district}
                                setDistrict={setDistrict}
                                city={city}
                                setCity={setCity}
                                state={state}
                                setState={setState}
                                type={type}
                                setType={setType}
                                admins={admins}
                                admin={admin}
                                setAdmin={setAdmin}
                                canViewPrice={canViewPrice}
                                setCanViewPrice={setCanViewPrice}
                                comments={comments}
                                setComments={setComments}
                            />,
                            <AddressTab
                                type={`shipping`}
                                customer={customer}
                                onAddressUpdated={getCustomer}
                            />,
                            <AddressTab
                                type={`billing`}
                                customer={customer}
                                onAddressUpdated={getCustomer}
                            />,
                            <QuotesTab
                                quotes={customer?.budgets ?? []}
                            />,
                            <OrdersTab
                                orders={customer?.orders ?? []}
                            />,
                            // Pessoa física guarda o logotipo nela; havendo
                            // empresa, ele fica na empresa (BDM-1130).
                            <CustomerLogotypes customerId={id} />
                        ]}
                    />
                }
                <PageFooter spaceBetween={true}>
                    <>
                        <div>
                            {hasPermission('edit_customer') &&
                                <>
                                    <Button type={`primary`} size={`small`} svg={`save-white`} text={`Salvar alterações`} action={updateCustomer} />
                                    <Button type={`secondary`} size={`small`} text={`Resetar senha`} action={() => setShowResetPassword(true)} />
                                </>
                            }
                        </div>
                        {hasPermission('delete_customer') &&
                            <Button type={`secondary`} size={`small`} svg={`delete-small`} text={`Excluir`} action={() => setConfirmDelete(true)} />
                        }
                    </>
                </PageFooter>
            </PanelTemplate>
        </>
    );
}

export default CustomerEdit;